import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "faq-unit" }
const _hoisted_2 = { class: "faq-unit__text-box" }
const _hoisted_3 = { class: "faq-unit__text" }

import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FAQUnit',
  props: {
    title: {}
  },
  setup(__props: any) {



const collapsed = ref(true)

function toggleCollapsible(): void {
  collapsed.value = !collapsed.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["faq-unit__title", { 'faq-unit__title--open': !collapsed.value }]),
      onClick: toggleCollapsible
    }, [
      _createTextVNode(_toDisplayString(__props.title) + " ", 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "faq-unit__icon-wrapper" }, [
        _createElementVNode("span", { class: "faq-unit__icon iconfont ifaq" })
      ], -1))
    ], 2),
    _createVNode(_Transition, { name: "faq" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 512), [
          [_vShow, !collapsed.value]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})